var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zm-button',{staticClass:"opc-succezz__view__account",attrs:{"size":"large","type":_vm.type,"round":""},on:{"click":_vm.goToBillingPage}},[_vm._v(_vm._s(_vm.$t('billing.success.confirmation.view_my_plan'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }